/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Urls_PlaceholderInputs */

const en_admin_indexnow_urls_placeholder = /** @type {(inputs: Admin_Indexnow_Urls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://example.com/new-page`)
};

/**
* | output |
* | --- |
* | "https://example.com/new-page" |
*
* @param {Admin_Indexnow_Urls_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_urls_placeholder = /** @type {((inputs?: Admin_Indexnow_Urls_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Urls_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_urls_placeholder(inputs)
});
export { admin_indexnow_urls_placeholder as "admin.indexnow.urls_placeholder" }